/**
 * Labels hotel cart lines and persisted booking rows so GDS vs off-market catalogue stays are easy to scan.
 *
 * Accepts: agent cart item, checkout payload line, or API booking (`bookingData.originalCartItem`, etc.).
 */
export function getHotelStaySourcePresentation(record) {
  if (record?.staySourceKind === 'off_market') {
    const id =
      record?.staySourceCatalogId != null ? String(record.staySourceCatalogId).trim() : ''
    return {
      variant: 'offMarket',
      pillText: 'Off-market stay',
      detailText: id ? `Catalog property ID: ${id}` : 'Exclusive catalogue (not standard GDS publish)'
    }
  }
  if (record?.staySourceKind === 'gds') {
    return {
      variant: 'gds',
      pillText: 'hotel',
      detailText: null
    }
  }

  const nestedCart =
    record?.bookingData?.originalCartItem ||
    record?.generalBackupMetadata?.additionalDetails?.originalCartItem ||
    null

  const isOffMarket =
    nestedCart?.isOffMarketStay === true ||
    record?.isOffMarketStay === true ||
    record?.bookingReferenceType === 'OFF_MARKET_STAY'

  let id = ''
  if (isOffMarket) {
    const fromNested =
      nestedCart?.offMarketPropertyId != null ? String(nestedCart.offMarketPropertyId).trim() : ''
    const fromRoot =
      record?.offMarketPropertyId != null ? String(record.offMarketPropertyId).trim() : ''
    id = fromNested || fromRoot
  }

  if (isOffMarket) {
    return {
      variant: 'offMarket',
      pillText: 'Off-market stay',
      detailText: id ? `Catalog property ID: ${id}` : 'Exclusive catalogue (not standard GDS publish)'
    }
  }
  return {
    variant: 'gds',
    pillText: 'hotel',
    detailText: null
  }
}
